import React, { FC, useState, useEffect, useContext } from 'react'

import { ModalContainer } from '../style'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import { CloseButton } from '../../shared/NavigationBar/SettingsMenu/SettingsMenu'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'






interface InfoModalInterface {
  closeButtonAction: Function
}

const InfoModal: FC<InfoModalInterface> = ({ closeButtonAction }) => {





  return (
    <ModalContainer>
      <GenericCloseButton color="white" onClick={closeButtonAction}></GenericCloseButton>
      <GenericTextSpan fSize="1.3rem" tAlign="left" width="100%" margin="0 0 2.5% 0" lineHeight="1.35rem">
        Każde z Wyzwań, to 10 specjalnie wyselekcjonowanych, miazgowych treningów, które możesz wykonywać naprzemiennie, co drugi dzień, przez kolejne 4 tygodnie. Po dwóch pierwszych tygodniach, jeśli poczujesz, że ćwiczenia są dla Ciebie zbyt łatwe, dołóż obciążenie w postaci cięższych hantli.
      </GenericTextSpan>
      <GenericTextSpan fSize="1.3rem" tAlign="left" width="100%" margin="0 0 2.5% 0" lineHeight="1.35rem">
        Każde z Wyzwań, to 10 specjalnie wyselekcjonowanych, miazgowych treningów, które możesz wykonywać naprzemiennie, co drugi dzień, przez kolejne 4 tygodnie. Po dwóch pierwszych tygodniach, jeśli poczujesz, że ćwiczenia są dla Ciebie zbyt łatwe, dołóż obciążenie w postaci cięższych hantli.
      </GenericTextSpan>
      <GenericTextSpan fSize="1.3rem" tAlign="left" width="100%" margin="0 0 2.5% 0" lineHeight="1.35rem">
        Po upływie 4 tygodni, powinnaś zmienić zestaw ćwiczeń, bo Twoje ciało będzie potrzebowało nowego bodźca do kolejnych zmian.
        „Brzuch w ogniu”, to moja propozycja na pracę nad mięśniami brzucha oraz nad stabilizacją, bez której nie zbudujesz odpowiedniego gorsetu mięśniowego.
      </GenericTextSpan>
      <GenericTextSpan fSize="1.3rem" tAlign="left" width="100%" margin="0 0 2.5% 0" lineHeight="1.35rem">
        „Spalanie” to najlepsza z opcji na pozbycie się nadmiaru tłuszczu i ujędrnienie ciała.
        Każde z „Wyzwań” podzielone jest na poziomy trudności, więc bądź pewna, że wybierasz odpowiedni do swojego poziomu treningowego - zbyt trudny Cię zniechęci, bo nie wykonasz większości ćwiczeń, a i możesz nabawić się kontuzji; zbyt łatwy nie będzie efektywny, więc obie te opcje nie dadzą wymarzonych efektów.
      </GenericTextSpan>
      <GenericTextSpan fSize="1.3rem" tAlign="left" width="100%" margin="0 0 2.5% 0" lineHeight="1.35rem">
        Pamiętaj, że wykupując Wyzwanie masz bezpłatny dostęp do panelu DIETY oraz do działu TECHNIKA. Korzystaj, bo WARTO!
      </GenericTextSpan>
      <GenericTextSpan fSize="1.7rem" fWeight="bold" tAlign="left" width="100%" margin="3% 0% 1% 0" >
        Zdecydowana?
      </GenericTextSpan>
      <GenericTextSpan fSize="1.7rem" fWeight="bold" tAlign="left" width="100%" margin="0 0 1% 0">
        To chodź!
      </GenericTextSpan>
      <GenericTextSpan fSize="1.7rem" fWeight="bold" tAlign="left" width="100%">
        Szkoda tracić czas.
      </GenericTextSpan>

    </ModalContainer>
  )
}

export default InfoModal
